import { serviceRequest } from 'utils/http';
import { ForgotPasswordDto, Service } from 'common/api';

export function sendForgotPasswordEmailAPI(requestBody: ForgotPasswordDto) {
  return serviceRequest(() => Service.siteEmployeeControllerSendForgotPasswordEmail(requestBody));
}
